import { supabase } from "../supabaseClient";

async function getAllProjects() {
    const query = await supabase.from('Projects').select('*', { count: 'exact' }).eq('isVJ', true);
    const { data, error, count } = await query;
    if (data) return { data, count };
    else throw error;
}


async function getSelectedProjects(userId) {
    const query = await supabase.from('SustenanceSalesRelations').select('*', { count: 'exact' }).eq("userId", userId);
    const { data, error, count } = query;
    if (data) return { data, count };
    else throw error;
}


async function getSalesProjects(userId) {
    const query = await supabase.from('SustenanceSalesRelations').select('* , projectId(*)', { count: 'exact' }).eq("userId", userId);
    const { data, error, count } = query;
    if (data) return { data, count };
    else throw error;
}


async function addSelectedProjects(postBody, unCheckedProjects) {
    return new Promise((resolve, reject) => {

        console.log(postBody);

        if (unCheckedProjects) {
            unCheckedProjects.map(async (item) => {
                await supabase.from('SustenanceSalesRelations').delete().eq('projectId', item.projectId).eq("userId", item.userId);
            })
        }

        // unCheckedProjects.map((item) => {
        //     console.log("uncheck : ", item)
        // })
        let count = 0;
        postBody.map(async (item) => {
            const query = await supabase.from('SustenanceSalesRelations').select('*', { count: 'exact' }).eq('userId', item.userId).eq('projectId', item.projectId);
            // const query = await supabase.from('SustenanceSalesRelations').select('*', { count: 'exact' }).eq('userId', item.userId).eq('projectId', item.projectId).maybeSingle();

            if (query.data.length === 0) {
                //     //  ! if already assigned, no changes
                // } else {
                const { data, error } = await supabase.from("SustenanceSalesRelations").insert({ userId: item.userId, projectId: item.projectId, last_updated_at: new Date().getTime() });

                console.log('insert query', query);
                // ! vedashree changes here ====> to do : change this query
                // const { data, error } = await supabase
                //     .from('SustenanceSalesRelations')
                //     .upsert({ userId: item.userId, projectId: item.projectId, created_at: item.created_at, last_updated_at: item.last_updated_at, sustenanceSalesRelationId: item.sustenanceSalesRelationId })
                // if (data) {
                console.log(data);
                count++;
                if (count === postBody.length) {
                    resolve(true);
                }
                // }
                // else throw error;

            } else {
                count++;
                if (count === postBody.length) {
                    resolve(true);
                }
            }

        })
    });

    // return await insertQuery("SustenanceSalesRelations", postBody).select("*");
    // const query = await supabase.from('SustenanceSalesRelations').select('*', { count: 'exact' }).eq('userId', '38b20b6b-3aa2-4704-991d-b999615d0e74').eq('projectId', 'c09a9d42-92e9-42f4-8529-a6561be73303');


    // const { data, error } = await supabase
    //     .from('SustenanceSalesRelations')
    //     .upsert({userId: item.userId, projectId: item.projectId, last_updated_at: item.last_updated_at})
    //     if (data) return { data };
    //     else throw error;
    // await supabase.from('SustenanceSalesRelations').delete().eq('userId', '38b20b6b-3aa2-4704-991d-b999615d0e74');
}

export {
    getAllProjects,
    getSelectedProjects,
    addSelectedProjects,
    getSalesProjects,
}